// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3sHWr":[function(require,module,exports) {
require("2b6d5ead678b4549").register(require("4532326affbb838e").getBundleURL("c4cLN"), JSON.parse('["c4cLN","index.js","kMKFg","jose.cc54f90f.js","dVcvk","LoginWallOverlay.mh.426d1b93.js","7SBQa","LoginWallOverlay.nb.907aedaa.js","kNLVx","LoginWallOverlay.gva.f0c1a140.js","6nVKT","LoginWallOverlay.hbvl.eebbebe2.js","14QDh","LoginWallOverlay.ds.ae113db5.js","2zjTs","LoginWallOverlay.dl.9b887948.js","iOSSR","LoginWallOverlay.nhd.522bf830.js","jdd4K","LoginWallOverlay.ge.d3dcf050.js","e0Rep","LoginWallOverlay.yc.a384c4a6.js","QdmLN","LoginWallOverlay.hd.bcd0417d.js","jqHnS","LoginWallOverlay.ld.ba2c5308.js","95IVm","LoginWallOverlay.az.4fcebfb2.js","j5vQM","LoginWall.mh.74a69233.js","kuwyQ","LoginWall.nb.c8d55374.js","hpmJK","LoginWall.gva.79fb2dab.js","75rVb","LoginWall.hbvl.72a6953a.js","jvVie","LoginWall.ds.3ff9da3d.js","1Rec2","LoginWall.dl.401772ca.js","eP5WB","LoginWall.nhd.9aad8e83.js","cSUAJ","LoginWall.ge.a70638c8.js","ktfFT","LoginWall.yc.aac292fe.js","6vrJm","LoginWall.hd.6838addc.js","ahuud","LoginWall.ld.cb52e29f.js","ju3C7","LoginWall.az.0792f020.js","8TPB0","IdentityWallOverlay.mh.f0df3540.js","dKktD","IdentityWallOverlay.nb.4951d3fa.js","1nR1M","IdentityWallOverlay.gva.67574a3e.js","aJj8f","IdentityWallOverlay.hbvl.c7ad1980.js","k2nJc","IdentityWallOverlay.ds.0ce84b0a.js","5hQ26","IdentityWallOverlay.dl.1ffe5a88.js","20EWj","IdentityWallOverlay.nhd.5a438fcb.js","257xd","IdentityWallOverlay.ge.ce08b5ae.js","5YLOB","IdentityWallOverlay.yc.cde6835b.js","clg2W","IdentityWallOverlay.hd.5b2a3b27.js","cYyjx","IdentityWallOverlay.ld.bf51ec5d.js","hQARm","IdentityWallOverlay.az.52860d0d.js","4c16t","IdentityWall.mh.c62110cc.js","2W8Qq","IdentityWall.nb.2ef56700.js","gia0u","IdentityWall.gva.fc67bc6f.js","7v639","IdentityWall.hbvl.d3850f4b.js","OfjZN","IdentityWall.ds.99eeb46c.js","jNzC2","IdentityWall.dl.c2bbc2bc.js","3UHWR","IdentityWall.nhd.07723b7a.js","5JGOU","IdentityWall.ge.dd2b6e0c.js","cqhLa","IdentityWall.yc.f938690d.js","7cQwd","IdentityWall.hd.8d4eb9bb.js","lEVfn","IdentityWall.ld.b62e4226.js","dmlb4","IdentityWall.az.1ec2b4d9.js","ajzeL","EmailConfirmationWall.mh.1b12527a.js","3muPS","EmailConfirmationWall.nb.ff0748d1.js","cTJLt","EmailConfirmationWall.gva.2bfe0d3c.js","llb2B","EmailConfirmationWall.hbvl.06bbd80e.js","lKOLb","EmailConfirmationWall.ds.7b0a2deb.js","5RqXX","EmailConfirmationWall.dl.3a96210f.js","QEpwI","EmailConfirmationWall.nhd.248a5251.js","ef0Jm","EmailConfirmationWall.ge.85cdcbb2.js","de8wm","EmailConfirmationWall.yc.2745b35d.js","7s5QD","EmailConfirmationWall.hd.ef4a1e46.js","91Lro","EmailConfirmationWall.ld.9f18ed67.js","ho7rd","EmailConfirmationWall.az.f753284b.js","aZzFr","NotificationToast.mh.8bb40f12.js","4SbtD","NotificationToast.nb.4f3a77c8.js","f4SOf","NotificationToast.gva.04fee228.js","hBDBK","NotificationToast.hbvl.9ad95a59.js","2o74t","NotificationToast.ds.fc6d7a41.js","5ZRJS","NotificationToast.dl.722130e5.js","8C1BM","NotificationToast.nhd.e7f4603d.js","9otOP","NotificationToast.ge.1498befc.js","CUJ9S","NotificationToast.yc.45404df4.js","7SGkM","NotificationToast.hd.8bd94ebd.js","3Eoqt","NotificationToast.ld.ae79dc28.js","dzqic","NotificationToast.az.7a51ecb5.js"]'));

},{"2b6d5ead678b4549":"fyJL2","4532326affbb838e":"c7Tr5"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"8RSWf":[function(require,module,exports) {
var _auth0Sdk = require("./auth0-sdk");
(()=>{
    const queue = window.CIAM || [];
    window.CIAM = {
        push: (fn)=>{
            fn();
        },
        getIdToken: (0, _auth0Sdk.getIdToken),
        getAccessToken: (0, _auth0Sdk.getAccessToken),
        getUserInfo: (0, _auth0Sdk.getUserInfo),
        getFullUserProfile: (0, _auth0Sdk.getFullUserProfile),
        getDecodedIdToken: (0, _auth0Sdk.getDecodedIdToken),
        getDecodedAccessToken: (0, _auth0Sdk.getDecodedAccessToken),
        refreshAccessToken: (0, _auth0Sdk.refreshAccessToken),
        isAuthenticated: (0, _auth0Sdk.isAuthenticated),
        isEmailVerified: (0, _auth0Sdk.isEmailVerified),
        showEmailConfirmation: (0, _auth0Sdk.showEmailConfirmation),
        showLoginWall: (0, _auth0Sdk.showLoginWall),
        showIdentityWall: (0, _auth0Sdk.showIdentityWall),
        showSilentLoginNotification: (0, _auth0Sdk.showSilentLoginNotification),
        sendEmailVerification: (0, _auth0Sdk.sendEmailVerification),
        getUserSubscriptions: (0, _auth0Sdk.getUserSubscriptions),
        getUserEntitlements: (0, _auth0Sdk.getUserEntitlements),
        getLoginUrl: (0, _auth0Sdk.getLoginUrl),
        getRegisterUrl: (0, _auth0Sdk.getRegisterUrl),
        getConfig: (0, _auth0Sdk.getConfig),
        hasIdentityLevel: (0, _auth0Sdk.hasIdentityLevel),
        initializeSessionManager: (0, _auth0Sdk.initializeSessionManager),
        on: (0, _auth0Sdk.on),
        off: (0, _auth0Sdk.off)
    };
    if (Array.isArray(queue)) queue.forEach((fn)=>fn());
    if (window?.location?.search?.includes("_sl=")) {
        const searchParams = new URLSearchParams(window.location.search);
        if (!document.getElementById("auth0_silent-login-root")) {
            var doc = document.createElement("div");
            doc.id = "auth0_silent-login-root";
            document.body.appendChild(doc);
        }
        (0, _auth0Sdk.showSilentLoginNotification)({
            clientId: searchParams.get("_sl"),
            el: document.getElementById("auth0_silent-login-root"),
            language: searchParams.get("_sl_ui_locales") || "nl"
        });
    }
    if (window?.location?.search?.includes("force_sl=1")) {
        const parsedUrl = new URL(window.location.href);
        parsedUrl.searchParams.delete("force_sl");
        window.history.replaceState(history.state, undefined, parsedUrl.toString());
    }
})();

},{"./auth0-sdk":"3ELjX"}],"3ELjX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get the client configuration from cookies.
 *
 * @returns {Config}
 */ parcelHelpers.export(exports, "getConfig", ()=>getConfig);
/**
 * Get the access token of a logged in user. Useful when you need to send this token to a backend service from the client.
 *
 * @returns Access token or null
 */ parcelHelpers.export(exports, "getAccessToken", ()=>getAccessToken);
/**
 * Returns all subscribed access claims.
 *
 * @deprecated Use {@link getUserEntitlements} instead. The `subscribed-accesses` claim is being
 * superseded by the richer `entitlements` claim and will be removed from the access token.
 * @returns The list of claims
 */ parcelHelpers.export(exports, "getUserSubscriptions", ()=>getUserSubscriptions);
/**
 * Returns the user's entitlements as read from the access token's `entitlements` claim.
 * Each entitlement lists the active access claims and roles for the current brand.
 *
 * @returns The list of entitlements, or an empty array when none are present
 */ parcelHelpers.export(exports, "getUserEntitlements", ()=>getUserEntitlements);
/**
 * Returns the access token fully parsed and decoded of a loggedin user.
 *
 * @returns The parsed access token or null
 */ parcelHelpers.export(exports, "getDecodedAccessToken", ()=>getDecodedAccessToken);
/**
 * Retrieve the raw id token of a logged in user. If you're looking to extract this infomration you can simply use the `getUserInfo` function instead.
 *
 * @returns Raw JWT id token or null
 */ parcelHelpers.export(exports, "getIdToken", ()=>getIdToken);
/**
 * Returns the id token fully parsed and decoded of a loggedin user.
 *
 * @returns The parsed id token or null
 */ parcelHelpers.export(exports, "getDecodedIdToken", ()=>getDecodedIdToken);
/**
 * Returns the id token fully parsed and decoded of a loggedin user.
 *
 * @returns The parsed id token or null
 */ parcelHelpers.export(exports, "getUserInfo", ()=>getUserInfo);
/**
 * Returns the id token fully parsed and decoded of a loggedin user.
 *
 * @param clientId Auth0 client id
 * @returns The parsed id token or null
 */ parcelHelpers.export(exports, "getFullUserProfile", ()=>getFullUserProfile);
/**
 * Refreshes the access token of a logged in user.
 *
 * @returns True if the token was succesfully refreshed, false otherwise
 */ parcelHelpers.export(exports, "refreshAccessToken", ()=>refreshAccessToken);
/**
 * Attach a listener to an event.
 *
 * @param event the name of the event to listen to
 * @param callback your callback function
 */ parcelHelpers.export(exports, "on", ()=>on);
/**
 * Detach a listener to an event.
 *
 * @param event the name of the event to listen to
 * @param callback your callback function
 */ parcelHelpers.export(exports, "off", ()=>off);
/**
 * Is the user authenticated?
 *
 * @returns True if the user is authenticated, false otherwise
 */ parcelHelpers.export(exports, "isAuthenticated", ()=>isAuthenticated);
/**
 * Is the email verified?
 *
 * @returns True if the email is verified, false otherwise
 */ parcelHelpers.export(exports, "isEmailVerified", ()=>isEmailVerified);
parcelHelpers.export(exports, "hasIdentityLevel", ()=>hasIdentityLevel);
parcelHelpers.export(exports, "sendEmailVerification", ()=>sendEmailVerification);
/**
 * When not loggedin show login wall.
 * showLoginWall let you put our shared component based on the Mediahuis design system in your page.
 *
 * @param options The list of options to pass to the popup
 * @param options.type The type of email confirmation to show
 * @param options.loginIdentityLevel The identity level to login
 * @param options.registerIdentityLevel The identity level to register
 * @param options.el The DOM element to render the email confirmation in
 * @param options.slots.title Custom title for login wall
 * @param options.slots.content Custom content for login wall
 * @param options.slots.callToAction Custom call to action for login wall
 * @param options.onTrackEvent Function to track events
 * @returns
 */ parcelHelpers.export(exports, "showLoginWall", ()=>showLoginWall);
/**
 * Some brands require a specific identity level before reading any metered or plus articles.
 * showIdentityWall let you put our shared component based on the Mediahuis design system in your page.
 *
 * @param options The list of options to pass to the popup
 * @param options.clientId Auth0 client id
 * @param options.type The type of email confirmation to show
 * @param options.requiredIdentityLevel The identity level to progress
 * @param options.el The DOM element to render the email confirmation in
 * @param options.slots.title Custom title for login wall
 * @param options.slots.content Custom content for login wall
 * @param options.slots.callToAction Custom call to action for login wall
 * @param options.onTrackEvent Function to track events
 * @param options.options["ext-internal"] Internal tracking parameter
 * @returns
 */ parcelHelpers.export(exports, "showIdentityWall", ()=>showIdentityWall);
/**
 * Some brands require a specific identity to be show  before reading any metered or plus articles.
 *
 * @param options The list of options to pass to the popup
 * @param options.clientId Auth0 client id
 * @param options.type The type of email confirmation to show
 * @param options.el The DOM element to render the email confirmation in
 * @param options.onTrackEvent Function to track events
 * @returns
 */ parcelHelpers.export(exports, "showEmailConfirmation", ()=>showEmailConfirmation);
/**
 * If you want to control when to show the silent login popup.
 *
 * Note that we're using the Mediahuis design system to create these popups.
 *
 * @param options The list of options to pass to the popup
 * @param options.clientId Auth0 client id
 * @param options.el The DOM element to render the silent login notification in
 * @returns
 */ parcelHelpers.export(exports, "showSilentLoginNotification", ()=>showSilentLoginNotification);
parcelHelpers.export(exports, "Language", ()=>Language);
/**
 * Constructs the login URL with the specified parameters.
 *
 * @param clientId - The Auth0 client id.
 * @param identityLevel The identity level options required for login and registration.
 * @param identityLevel.loginIdentity The identity level required for login.
 * @param identityLevel.registerIdentity The identity level required for registration.
 * @param options - General options for constructing the URL.
 * @param options.skipEmailVerification - Whether to skip email verification. Defaults to false.
 * @param options.connection - The name of the social connection (e.g., 'mh-google-social' for Google).
 * @param options.returnTo - The URL to redirect to after login. Defaults to the current window location.
 * @param options.brand - The brand according to which CIAM should behave. !Only use if your client has to support multiple "brands", else configure this through the client config.
 * @param options.language - The language to be used by authentication screens. If not provided, default configured in cloudflare worker is used
 * @param tracking - Tracking options for analytics purposes.
 * @param tracking.articleId - Article ID for tracking.
 * @param tracking.prsid - PRS ID for tracking.
 * @param tracking.cid - CID for tracking.
 * @param tracking.internal - Internal tracking parameter.
 * @returns A promise that resolves to the constructed login URL as a string.
 */ parcelHelpers.export(exports, "getLoginUrl", ()=>getLoginUrl);
/**
 * Constructs the register URL with the specified parameters.
 *
 * @param clientId - The Auth0 client id.
 * @param identityLevel The identity level options required for login and registration.
 * @param identityLevel.loginIdentity The identity level required for login.
 * @param identityLevel.registerIdentity The identity level required for registration.
 * @param options - General options for constructing the URL.
 * @param options.skipEmailVerification - Whether to skip email verification. Defaults to false.
 * @param options.connection - The name of the social connection (e.g., 'mh-google-social' for Google).
 * @param options.returnTo - The URL to redirect to after registration. Defaults to the current window location.
 * @param options.brand The brand according to which CIAM should behave. !Only use if your client has to support multiple "brands", else configure this through the client config.
 * @param options.language The language to be used by authentication screens. If not provided, default configured in cloudflare worker is used
 * @param tracking - Tracking options for analytics purposes.
 * @param tracking.articleId - Article ID for tracking.
 * @param tracking.prsid - PRS ID for tracking.
 * @param tracking.cid - CID for tracking.
 * @param tracking.internal - Internal tracking parameter.
 * @returns A promise that resolves to the constructed register URL as a string.
 */ parcelHelpers.export(exports, "getRegisterUrl", ()=>getRegisterUrl);
/**
 * Initialize and connect to the global session manager.
 * @param clientId The clientID of the application
 * @param callbacks Optional callback functions for session events
 * @returns Promise<SessionManager>
 */ parcelHelpers.export(exports, "initializeSessionManager", ()=>initializeSessionManager);
var _cookie = require("./modules/cookie");
var _emitter = require("./utils/emitter");
var _pageVisibilityListener = require("./utils/pageVisibilityListener");
var _sessionManager = require("./modules/session-manager/SessionManager");
// Explicit clientId wins (still needed to disambiguate multiple clients on one host); otherwise
// resolve from the `ciam_active_client` cookie so client apps needn't know their client id.
function resolveClientId(clientId) {
    if (clientId) return clientId;
    const active = (0, _cookie.getActiveClient)();
    if (active?.clientId) return active.clientId;
    throw new Error("CIAM: no clientId provided and no active client cookie found. Pass a clientId explicitly, or make sure the page is served through the CIAM proxy worker.");
}
function getConfig(clientId) {
    const id = resolveClientId(clientId);
    const cookieValue = (0, _cookie.getCookie)(`${id}_config`);
    if (!cookieValue) throw new Error(`No config found for client id: ${id}`);
    const params = new URLSearchParams(cookieValue);
    return Array.from(params.entries()).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
function getAccessToken(clientId) {
    return (0, _cookie.getCookie)(`${resolveClientId(clientId)}_acc_token`);
}
async function getUserSubscriptions(clientId) {
    const decodedAccessToken = await getDecodedAccessToken(clientId);
    return decodedAccessToken?.["https://mediahuis.com/subscribed-accesses"] ?? [];
}
async function getUserEntitlements(clientId) {
    const decodedAccessToken = await getDecodedAccessToken(clientId);
    return decodedAccessToken?.["https://mediahuis.com/entitlements"] ?? [];
}
async function getDecodedAccessToken(clientId) {
    return (0, _cookie.extractToken)(`${resolveClientId(clientId)}_acc_token`);
}
function getIdToken(clientId) {
    return (0, _cookie.getCookie)(`${resolveClientId(clientId)}_id_token`);
}
async function getDecodedIdToken(clientId) {
    return (0, _cookie.extractToken)(`${resolveClientId(clientId)}_id_token`);
}
async function getUserInfo(clientId) {
    return getDecodedIdToken(clientId);
}
async function getFullUserProfile(clientId) {
    const id = resolveClientId(clientId);
    if (!isAuthenticated(id)) return null;
    const accessToken = await getDecodedAccessToken(id);
    const config = getConfig(id);
    let domain = `https://identity-management.mediahuis.com`;
    if (config.env === "test") domain = `https://identity-management-tst.mediahuis.com`;
    else if (config.env === "preview" || config.env === "staging") domain = `https://identity-management-uat.mediahuis.com`;
    else if (config.env === "dev") domain = `https://identity-management-dev.mediahuis.com`;
    const url = new URL(`/v4/api/identities/${accessToken.sub}`, domain);
    const response = await fetch(url, {
        headers: {
            authorization: `Bearer ${getAccessToken(id)}`
        }
    });
    if (!response.ok) return null;
    return response.json();
}
async function refreshAccessToken(clientId) {
    const basePath = getBasePath(resolveClientId(clientId));
    try {
        const response = await fetch(`${basePath}/auth/refresh`, {
            method: "POST"
        });
        if (!response.ok) return false;
        const { ok } = await response.json();
        return ok;
    } catch (_err) {
        return false;
    }
}
function on(clientId, event, callback) {
    const id = resolveClientId(clientId);
    // if someone is listening we can capture the clientId and start listening for expired tokens
    let isUserAuthenticated = isAuthenticated(id);
    let currentAccessToken = getAccessToken(id);
    (0, _pageVisibilityListener.registerPageVisibilityListener)(async (isVisible)=>{
        if (isVisible) {
            if (isUserAuthenticated) {
                // still authenticated but access token has changed
                if (isAuthenticated(id) && currentAccessToken !== getAccessToken(id)) {
                    (0, _emitter.getEmitter)().emit((0, _emitter.generateEventName)("auth:session_changed", id));
                    currentAccessToken = getAccessToken(id);
                    return;
                }
                const accessToken = await getDecodedAccessToken(id);
                // if expired
                const tokenExpirationSkew = 300000;
                if (!isAuthenticated(id) || accessToken?.exp * 1000 <= Date.now() + tokenExpirationSkew /*5min*/ ) {
                    const isRefreshed = await refreshAccessToken(id);
                    isUserAuthenticated = isAuthenticated(id);
                    if (isRefreshed) {
                        currentAccessToken = getAccessToken(id);
                        (0, _emitter.getEmitter)().emit((0, _emitter.generateEventName)("auth:session_changed", id));
                    } else (0, _emitter.getEmitter)().emit((0, _emitter.generateEventName)("auth:session_expired", id));
                }
            } else if (isAuthenticated(id)) {
                (0, _emitter.getEmitter)().emit((0, _emitter.generateEventName)("auth:session_changed", id));
                currentAccessToken = getAccessToken(id);
                isUserAuthenticated = true;
            }
        }
    });
    (0, _emitter.getEmitter)().on((0, _emitter.generateEventName)(event, id), callback);
}
function off(clientId, event, callback) {
    (0, _emitter.getEmitter)().off((0, _emitter.generateEventName)(event, resolveClientId(clientId)), callback);
}
function isAuthenticated(clientId) {
    const id = resolveClientId(clientId);
    return !!getAccessToken(id) && !!getIdToken(id);
}
async function isEmailVerified(clientId) {
    const userInfo = await getUserInfo(clientId);
    if (!userInfo) return false;
    return userInfo.email_verified;
}
function getBasePath(clientId) {
    const config = getConfig(clientId);
    return config.prefix === "/" ? "" : config.prefix;
}
async function hasIdentityLevel(clientId, identityLevel) {
    const accessToken = await getDecodedAccessToken(clientId);
    return accessToken["https://mediahuis.com/identity-levels"]?.includes(identityLevel) ?? false;
}
async function sendEmailVerification(clientId) {
    const id = resolveClientId(clientId);
    const userInfo = await getDecodedIdToken(id);
    if (userInfo.email_verified) return false;
    const basePath = getBasePath(id);
    const verifyEmailUrl = new URL(`${basePath}/auth/verify-email`, window.location.origin);
    verifyEmailUrl.searchParams.append("accountId", userInfo.sub);
    try {
        const resp = await fetch(verifyEmailUrl, {
            headers: {
                authorization: "Bearer " + getAccessToken(id)
            }
        });
        return resp.ok;
    } catch (err) {
        return false;
    }
}
async function showLoginWall({ type, clientId, loginIdentityLevel, registerIdentityLevel, el, slots = {}, options, onTrackEvent }) {
    const id = resolveClientId(clientId);
    if (![
        "paywall",
        "inline",
        "overlay"
    ].includes(type)) throw new Error(`Unsupported type: ${type}, only paywall, inline or overlay is currently implemented.`);
    if (!el) throw new Error(`No element provided to render the identity wall in.`);
    if (isAuthenticated(id)) throw new Error(`User is authenticated.`);
    const config = getConfig(id);
    if (type === "overlay") {
        const { appendLoginWall } = await {
            mh: require("b06c8d5be285011"),
            nb: require("5ac405ed98c2874"),
            gva: require("86bd40b823258e10"),
            hbvl: require("608b9e7d2265d564"),
            ds: require("36ca43390b8f1de1"),
            dl: require("829253ae9520c44e"),
            nhd: require("a1ce44bb447c1e5c"),
            ge: require("954a1db98e5fa7e6"),
            yc: require("b8efff27cdb738b9"),
            hd: require("4e93fe45cae499c3"),
            ld: require("4fec8f51eee82732"),
            az: require("e5e29ee09258f6d2")
        }[config.brand];
        return appendLoginWall(el, {
            requiredLoginIdentityLevel: loginIdentityLevel,
            requiredRegisterIdentityLevel: registerIdentityLevel,
            brand: config.brand,
            slots,
            onTrackEvent,
            options
        });
    } else {
        const { appendLoginWall } = await {
            mh: require("4e8a5a660078958f"),
            nb: require("e4d298e589efe723"),
            gva: require("e2de46407845cc49"),
            hbvl: require("499927e8f43c1aad"),
            ds: require("35e616265ef4c7d0"),
            dl: require("3d6377345c774070"),
            nhd: require("2fc7e88eece64"),
            ge: require("eb4308b3d411355b"),
            yc: require("4d75e431d996a7bd"),
            hd: require("4b92afc2e15227b9"),
            ld: require("b9c4edeb7343e9e8"),
            az: require("e18a4dc2350432f0")
        }[config.brand];
        return appendLoginWall(el, {
            requiredLoginIdentityLevel: loginIdentityLevel,
            requiredRegisterIdentityLevel: registerIdentityLevel,
            brand: config.brand,
            clientId: id,
            slots,
            onTrackEvent,
            options
        });
    }
}
async function showIdentityWall({ type, clientId, identityLevel, el, slots = {}, onTrackEvent, options }) {
    // if (type !== 'paywall') {
    // 	throw new Error(`Unsupported type: ${type}, only paywall is currently implemented.`);
    // }
    const id = resolveClientId(clientId);
    if (!el) throw new Error(`No element provided to render the identity wall in.`);
    if (!isAuthenticated(id)) throw new Error(`User is not authenticated.`);
    const config = getConfig(id);
    if (type === "overlay") {
        const { appendIdentityWall } = await {
            mh: require("f211afece82b3372"),
            nb: require("ece490d262e1340f"),
            gva: require("73b901db05e69ad"),
            hbvl: require("4a3494a78a34542f"),
            ds: require("4213ded863b24215"),
            dl: require("77cd712826b3c5c1"),
            nhd: require("8369d2fe790f6f32"),
            ge: require("7b647a799ced2cd9"),
            yc: require("afa5dd078f90f551"),
            hd: require("e178446f0c3aeff9"),
            ld: require("d34beff9be5506c5"),
            az: require("b71d8201890fd61e")
        }[config.brand];
        return appendIdentityWall(el, {
            requiredIdentityLevel: identityLevel,
            brand: config.brand,
            clientId: id,
            slots,
            onTrackEvent,
            options
        });
    } else {
        const { appendIdentityWall } = await {
            mh: require("f01685cdd1dfb443"),
            nb: require("75abb72238cc4dee"),
            gva: require("4bca765fce46af51"),
            hbvl: require("e594674c719ab553"),
            ds: require("789801a03e5e140e"),
            dl: require("572244af4c80585b"),
            nhd: require("da9961e0ff4d5c35"),
            ge: require("3ca91b97cffb0761"),
            yc: require("4cdf562db955f7ba"),
            hd: require("74ba864ba7b089c9"),
            ld: require("b33b77412b0b3faa"),
            az: require("10a88c3c1fc31c46")
        }[config.brand];
        return appendIdentityWall(el, {
            requiredIdentityLevel: identityLevel,
            brand: config.brand,
            clientId: id,
            slots,
            onTrackEvent,
            options
        });
    }
}
async function showEmailConfirmation({ type, clientId, el, onTrackEvent }) {
    const id = resolveClientId(clientId);
    if (type !== "paywall" && type !== "inline") throw new Error(`Unsupported type: ${type}, only paywall or inline is currently implemented.`);
    if (!isAuthenticated(id)) throw new Error(`User is not authenticated.`);
    if (!el) throw new Error(`No element provided to render the email confirmation box in.`);
    const userInfo = await getDecodedIdToken(id);
    if (userInfo.email_verified) throw new Error(`User has already been verified.`);
    const config = getConfig(id);
    const { appendEmailVerificationWall } = await {
        mh: require("f302053403f46072"),
        nb: require("cf77df45f5c63fa8"),
        gva: require("e2d034d075638bd3"),
        hbvl: require("8b5901e6485a7c11"),
        ds: require("74334ec3b2e4a30"),
        dl: require("484b45870643fb"),
        nhd: require("dc544af4e7bfc5ba"),
        ge: require("28fbd7aa9405e905"),
        yc: require("680c4bc6217b9430"),
        hd: require("c79b001df3a1cd4e"),
        ld: require("d79ec99ca5a32e31"),
        az: require("e474b29626606e42")
    }[config.brand];
    return appendEmailVerificationWall(el, {
        email: userInfo.email,
        brand: config.brand,
        clientId: id,
        onTrackEvent
    });
}
async function showSilentLoginNotification({ clientId, el, language }) {
    const id = resolveClientId(clientId);
    const parsedUrl = new URL(window.location.href);
    parsedUrl.searchParams.delete("_sl");
    parsedUrl.searchParams.delete("_sl_ui_locales");
    window.history.replaceState(history.state, undefined, parsedUrl.toString());
    const userInfo = await getUserInfo(id);
    if (!userInfo.email) return;
    if (!el) throw new Error(`No element provided to render the silent login toast in.`);
    const { appendNotificationToast } = await {
        mh: require("481b112c9d50f416"),
        nb: require("aa52a3fca85317ac"),
        gva: require("9d13c54cd4c0ebd9"),
        hbvl: require("bd86f32227ae71d4"),
        ds: require("3338b7bea32464df"),
        dl: require("5f80b6be8de0b1f0"),
        nhd: require("7a92099a245c93b4"),
        ge: require("238231a235630333"),
        yc: require("eaa27e934c937fe3"),
        hd: require("438404de06674214"),
        ld: require("b0c5f264b41b18fa"),
        az: require("3d0186b691b7fdc0")
    }["mh"];
    Object.assign(el.style, {
        position: "fixed",
        zIndex: "9999",
        top: 0,
        right: 0
    });
    const config = getConfig(id);
    await appendNotificationToast(el, {
        email: userInfo.email,
        brand: config.brand,
        language
    });
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
var Language;
(function(Language) {
    Language["NL"] = "nl";
    Language["FR"] = "fr-FR";
    Language["DE"] = "de";
    Language["EN"] = "en";
    Language["PT"] = "pt-PT";
})(Language || (Language = {}));
async function getLoginUrl({ clientId, identityLevel, options, tracking }) {
    return await buildUrl({
        identityLevel: identityLevel,
        options: options,
        tracking: tracking,
        clientId: clientId,
        authType: "login"
    });
}
async function getRegisterUrl({ clientId, identityLevel, options, tracking }) {
    return await buildUrl({
        identityLevel: identityLevel,
        options: options,
        tracking: tracking,
        clientId: clientId,
        authType: "register"
    });
}
/**
 * Constructs a URL with the specified parameters for either login or registration.
 *
 * @param searchParams - The URL search parameters to be appended.
 * @param options - General options for constructing the URL.
 * @param options.skipEmailVerification - Whether to skip email verification. Defaults to false.
 * @param options.connection - The name of the social connection (e.g., 'mh-google-social' for Google).
 * @param options.returnTo - The URL to redirect to after the operation. Defaults to the current window location.
 * @param options.brand - The brand according to which CIAM should behave. !Only use if your client has to support multiple "brands", else configure this through the client config.
 * @param options.language - The language to be used by authentication screens. If not provided, default configured in ??? is used
 * @param tracking - Tracking options for analytics purposes.
 * @param tracking.articleId - Article ID for tracking.
 * @param tracking.prsid - PRS ID for tracking.
 * @param tracking.cid - CID for tracking.
 * @param tracking.internal - Internal tracking parameter.
 * @param clientId - The Auth0 client id.
 * @param authType - The type of authentication ('login' or 'register').
 * @returns A promise that resolves to the constructed URL as a string.
 */ async function buildUrl({ identityLevel, options: { skipEmailVerification = false, connection, returnTo = window.location.href, brand, language }, tracking, clientId, authType }) {
    const searchParams = new URLSearchParams();
    const config = getConfig(clientId);
    if (identityLevel.loginIdentity) searchParams.append("login_identity_level", identityLevel.loginIdentity);
    if (identityLevel.registerIdentity) searchParams.append("register_identity_level", identityLevel.registerIdentity);
    searchParams.append("skip_email_verification", skipEmailVerification ? "1" : "0");
    if (connection) searchParams.append("connection", connection);
    if (returnTo) searchParams.append("returnTo", returnTo);
    if (tracking.prsid) searchParams.append("ext-prsid", tracking.prsid);
    if (tracking.cid) searchParams.append("ext-cid", tracking.cid);
    if (tracking.internal) searchParams.append("ext-internal", tracking.internal);
    if (tracking.articleId) searchParams.append("ext-articleId", tracking.articleId);
    if (language) searchParams.append("ui_locales", language);
    if (brand) searchParams.append("ext-brand", brand);
    let prefix = config.prefix ? config.prefix : "/";
    if (!prefix.endsWith("/")) prefix += "/";
    const resultUrl = new URL(`${window.location.origin}${prefix}auth/${authType}`);
    resultUrl.search = searchParams.toString();
    return resultUrl.toString();
}
let globalSessionManager = null;
async function initializeSessionManager(clientId, callbacks) {
    const id = resolveClientId(clientId);
    const config = getConfig(id);
    let sessionManagerEndpoint = "session-management.mediahuis.com";
    if (config.env === "dev") sessionManagerEndpoint = "session-management-dev.mediahuis.com";
    else if (config.env === "test") sessionManagerEndpoint = "session-management-tst.mediahuis.com";
    else if (config.env === "preview" || config.env === "staging") sessionManagerEndpoint = "session-management-uat.mediahuis.com";
    if (!globalSessionManager) globalSessionManager = new (0, _sessionManager.SessionManager)({
        sessionManagerEndpoint,
        clientId: id
    });
    if (callbacks?.onSessionBlocked) (0, _emitter.getEmitter)().on("session:blocked", callbacks.onSessionBlocked);
    if (callbacks?.onSessionUnblocked) (0, _emitter.getEmitter)().on("session:unblocked", callbacks.onSessionUnblocked);
    (0, _emitter.getEmitter)().on((0, _emitter.generateEventName)("auth:session_changed", id), async ()=>{
        await globalSessionManager.shutdown();
        globalSessionManager = new (0, _sessionManager.SessionManager)({
            sessionManagerEndpoint,
            clientId: id
        });
        await globalSessionManager.connect();
    });
    (0, _emitter.getEmitter)().on((0, _emitter.generateEventName)("auth:session_expired", id), async ()=>{
        await globalSessionManager.shutdown();
    });
    await globalSessionManager.connect();
    return globalSessionManager;
}

},{"./modules/cookie":"lK6AJ","./utils/emitter":"icruC","./utils/pageVisibilityListener":"3T4Bn","./modules/session-manager/SessionManager":"39Y4V","b06c8d5be285011":"gKyNT","5ac405ed98c2874":"a1Sgr","86bd40b823258e10":"6WxCn","608b9e7d2265d564":"8SJmv","36ca43390b8f1de1":"2J4qA","829253ae9520c44e":"8dMQO","a1ce44bb447c1e5c":"bEKLz","954a1db98e5fa7e6":"48zHh","b8efff27cdb738b9":"2mi3I","4e93fe45cae499c3":"ldtR5","4fec8f51eee82732":"lPHNd","e5e29ee09258f6d2":"krUjc","4e8a5a660078958f":"gtb31","e4d298e589efe723":"jRTqj","e2de46407845cc49":"1tpGP","499927e8f43c1aad":"7hEG8","35e616265ef4c7d0":"21AMv","3d6377345c774070":"3GCVy","2fc7e88eece64":"8xBP8","eb4308b3d411355b":"2wlKu","4d75e431d996a7bd":"fYaZG","4b92afc2e15227b9":"3eTZQ","b9c4edeb7343e9e8":"bgxJ8","e18a4dc2350432f0":"7Spzc","f211afece82b3372":"aZ4P9","ece490d262e1340f":"9k7cc","73b901db05e69ad":"91Iyr","4a3494a78a34542f":"kRz8l","4213ded863b24215":"f89mb","77cd712826b3c5c1":"8cxG0","8369d2fe790f6f32":"fuLOH","7b647a799ced2cd9":"Z3dTd","afa5dd078f90f551":"besK2","e178446f0c3aeff9":"3WjRM","d34beff9be5506c5":"4dWYW","b71d8201890fd61e":"fahcO","f01685cdd1dfb443":"4fphA","75abb72238cc4dee":"dipmP","4bca765fce46af51":"9QXik","e594674c719ab553":"03fHo","789801a03e5e140e":"1mGBB","572244af4c80585b":"eiIRf","da9961e0ff4d5c35":"dD3X6","3ca91b97cffb0761":"5CY5G","4cdf562db955f7ba":"e8eUp","74ba864ba7b089c9":"f4kPj","b33b77412b0b3faa":"5hAXt","10a88c3c1fc31c46":"04Atm","f302053403f46072":"brsVh","cf77df45f5c63fa8":"l07GF","e2d034d075638bd3":"dc5hV","8b5901e6485a7c11":"bTq5d","74334ec3b2e4a30":"it3xb","484b45870643fb":"5NfyA","dc544af4e7bfc5ba":"4cJ95","28fbd7aa9405e905":"lAONF","680c4bc6217b9430":"1W6z0","c79b001df3a1cd4e":"6D5WW","d79ec99ca5a32e31":"b3N5W","e474b29626606e42":"k95D2","481b112c9d50f416":"afemA","aa52a3fca85317ac":"eX6l3","9d13c54cd4c0ebd9":"idtxH","bd86f32227ae71d4":"m1NRc","3338b7bea32464df":"dJYr2","5f80b6be8de0b1f0":"iDqEx","7a92099a245c93b4":"8kiyi","238231a235630333":"dLch8","eaa27e934c937fe3":"61bFV","438404de06674214":"dTU9H","b0c5f264b41b18fa":"bYeQK","3d0186b691b7fdc0":"6svRp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lK6AJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Reads the `ciam_active_client` cookie and returns the client matching the active IDP, or null.
parcelHelpers.export(exports, "getActiveClient", ()=>getActiveClient);
// Prefix from the active-client cookie's provider; falls back to trying both when absent.
parcelHelpers.export(exports, "getCookie", ()=>getCookie);
parcelHelpers.export(exports, "extractToken", ()=>extractToken);
const ACTIVE_CLIENT_COOKIE = "ciam_active_client";
function getActiveClient() {
    const raw = getCookieByName(ACTIVE_CLIENT_COOKIE);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(decodeURIComponent(raw));
        const active = parsed.clients?.find((c)=>c.idp === parsed.activeIdp);
        if (!active?.id) return null;
        const provider = active.idp === "auth0" || active.idp === "fusionauth" ? active.idp : "";
        return {
            clientId: active.id,
            provider
        };
    } catch  {
        return null;
    }
}
function getCookie(cookieName) {
    const provider = getActiveClient()?.provider;
    if (provider === "auth0") return getCookieByName(`auth0_${cookieName}`);
    if (provider === "fusionauth") return getCookieByName(`ciam_${cookieName}`);
    return getCookieByName(`ciam_${cookieName}`) ?? getCookieByName(`auth0_${cookieName}`);
}
function getCookieByName(fullCookieName) {
    const cookies = document.cookie.split(";");
    for (const c of cookies){
        const [name, ...value] = c.split("=");
        if (name.trim() === fullCookieName) return value.join("=");
    }
    return null;
}
async function extractToken(cookieName) {
    const cookie = getCookie(cookieName);
    if (!cookie) return null;
    const { decodeJwt } = await require("c6e23692f19aac04");
    return decodeJwt(cookie);
}

},{"c6e23692f19aac04":"e5KkV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e5KkV":[function(require,module,exports) {
module.exports = require("605c7eba80b7e640")(require("1def5c81c628ea83").resolve("kMKFg")).then(()=>module.bundle.root("7mp50"));

},{"605c7eba80b7e640":"hpx0h","1def5c81c628ea83":"fyJL2"}],"hpx0h":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"1uYxD"}],"1uYxD":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"icruC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateEventName", ()=>generateEventName);
parcelHelpers.export(exports, "getEmitter", ()=>getEmitter);
var _mitt = require("mitt");
var _mittDefault = parcelHelpers.interopDefault(_mitt);
let emitterInstance = null;
function generateEventName(eventName, clientId) {
    return `${eventName}:${clientId}`;
}
function getEmitter() {
    if (!emitterInstance) emitterInstance = (0, _mittDefault.default)();
    return emitterInstance;
}

},{"mitt":"9VktN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VktN":[function(require,module,exports) {
var parcelHelpers = require("cfa4c44207791989");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(n) {
        return {
            all: n = n || new Map,
            on: function(t, e) {
                var i = n.get(t);
                i ? i.push(e) : n.set(t, [
                    e
                ]);
            },
            off: function(t, e) {
                var i = n.get(t);
                i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
            },
            emit: function(t, e) {
                var i = n.get(t);
                i && i.slice().map(function(n) {
                    n(e);
                }), (i = n.get("*")) && i.slice().map(function(n) {
                    n(t, e);
                });
            }
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151","cfa4c44207791989":"7baQq"}],"7baQq":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"3T4Bn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerPageVisibilityListener", ()=>registerPageVisibilityListener);
let listeners = [];
let isListenerAttached = false;
function registerPageVisibilityListener(cb) {
    listeners.push(cb);
    if (!isListenerAttached) {
        isListenerAttached = true;
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "visible") listeners.forEach((listener)=>listener(true));
            else listeners.forEach((listener)=>listener(false));
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39Y4V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionManager", ()=>SessionManager);
var _emitter = require("../../utils/emitter");
var _auth0Sdk = require("../../auth0-sdk");
var _rews = require("@nktkas/rews");
class SessionManager {
    constructor(options){
        this.ws = null;
        this._isInitialized = false;
        this.sessionState = null;
        this.pingIntervalId = null;
        this.onWebsocketSessionMessage = async (event)=>{
            if (event.data === "pong") return;
            const message = JSON.parse(event.data);
            this.sessionState = this.reduceSessionStateMessage(this.sessionState, message);
            this.applyState(this.sessionState);
        };
        this.onWebsocketClose = async (event)=>{
            console.log("Primary WebSocket closed:", event.code, event.reason);
            this.stopPing();
        };
        this.sessionManagerEndpoint = options.sessionManagerEndpoint;
        this.clientId = options.clientId;
        this.pingInterval = options.pingInterval ?? 30000;
    }
    async connect() {
        if (this._isInitialized) return;
        await this.establishWebSocketConnection();
        this._isInitialized = true;
    }
    startMediaConsumption() {
        this.ws.send(JSON.stringify({
            type: "startMediaConsumption"
        }));
    }
    endMediaConsumption() {
        this.ws.send(JSON.stringify({
            type: "endMediaConsumption"
        }));
    }
    applyState(state) {
        if (state) {
            if (state.isInConcurrencyLimitedContext && !state.isActive) (0, _emitter.getEmitter)().emit("session:blocked");
            else (0, _emitter.getEmitter)().emit("session:unblocked");
        }
        this.sessionState = state;
    }
    async establishWebSocketConnection() {
        if (this.ws?.readyState === WebSocket.OPEN) return;
        if (!(0, _auth0Sdk.isAuthenticated)(this.clientId)) throw new Error("User must be authenticated before initiating a session manager connection");
        const urlProvider = ()=>{
            const url = new URL(`wss://${this.sessionManagerEndpoint}`);
            url.pathname = "/join";
            url.searchParams.set("token", (0, _auth0Sdk.getIdToken)(this.clientId));
            return url.toString();
        };
        this.ws = new (0, _rews.ReconnectingWebSocket)(urlProvider, [
            "v1.mediahuis.session-manager+json"
        ], {
            maxRetries: null,
            reconnectionDelay: 5000
        });
        this.ws.onopen = ()=>{
            this.sessionState = null;
            this.startPing();
        };
        this.ws.onmessage = this.onWebsocketSessionMessage;
        this.ws.onclose = this.onWebsocketClose;
        this.ws.onerror = (error)=>{
            console.error("Primary WebSocket error:", error);
        };
    }
    reduceSessionStateMessage(prev, message) {
        if (message.type !== "sessionState") return prev;
        if (!prev || message.data.version > prev.version) return message.data;
        return prev;
    }
    startPing() {
        this.stopPing();
        this.pingIntervalId = setInterval(()=>{
            if (this.ws?.readyState === WebSocket.OPEN) this.ws.send("ping");
        }, this.pingInterval);
    }
    stopPing() {
        if (this.pingIntervalId !== null) {
            clearInterval(this.pingIntervalId);
            this.pingIntervalId = null;
        }
    }
    async shutdown() {
        this.stopPing();
        if (this.ws) {
            if (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING) this.ws.close(1000);
            this.ws = null;
        }
        this.sessionState = null;
        this._isInitialized = false;
    }
}

},{"../../utils/emitter":"icruC","../../auth0-sdk":"3ELjX","@nktkas/rews":"9sg0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9sg0q":[function(require,module,exports) {
// deno-lint-ignore-file no-explicit-any
/** Error thrown when reconnection fails in {@link ReconnectingWebSocket}. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReconnectingWebSocketError", ()=>ReconnectingWebSocketError);
/**
 * A WebSocket with auto-reconnection logic. Fully compatible with standard WebSocket API.
 *
 * Features:
 * - Automatic reconnection with configurable max retries and delay.
 * - Buffers messages sent while disconnected and sends them upon reconnection.
 * - Re-applies event listeners after reconnection.
 * - Supports dynamic URL and protocols via functions.
 *
 * Additional properties and events:
 * - `isTerminated`: Indicates whether the instance has been permanently terminated.
 * - `terminationReason`: If terminated, provides the reason for termination.
 * - `terminationSignal`: AbortSignal that is aborted when the instance is permanently terminated.
 * - `terminate` event: Fired when the instance is permanently terminated.
 */ parcelHelpers.export(exports, "ReconnectingWebSocket", ()=>ReconnectingWebSocket);
class ReconnectingWebSocketError extends Error {
    /**
     * Error code indicating the type of reconnection error:
     * - `RECONNECTION_LIMIT`: Maximum reconnection attempts reached
     * - `TERMINATED_BY_USER`: Closed via `close()` method
     * - `UNKNOWN_ERROR`: Unexpected failure during reconnection
     */ code;
    constructor(code, cause){
        super(`Error when reconnecting WebSocket: ${code}`);
        this.name = "ReconnectingWebSocketError";
        this.cause = cause;
        this.code = code;
    }
}
class ReconnectingWebSocket {
    _socket;
    _urlProvider;
    _protocolsProvider;
    _listeners = [];
    _attempt = 0;
    _messageBuffer = [];
    _abortController = new AbortController();
    /** Indicates whether the instance has been permanently terminated. */ get isTerminated() {
        return this._abortController.signal.aborted;
    }
    /** If terminated, provides the reason for termination. */ get terminationReason() {
        return this._abortController.signal.reason;
    }
    /** AbortSignal that is aborted when the instance is permanently terminated. */ get terminationSignal() {
        return this._abortController.signal;
    }
    /** Reconnection configuration options. */ reconnectOptions;
    constructor(url, protocolsOrOptions, maybeOptions){
        const protocols = typeof protocolsOrOptions === "string" || typeof protocolsOrOptions === "function" || Array.isArray(protocolsOrOptions) ? protocolsOrOptions : undefined;
        const options = typeof protocolsOrOptions === "object" && !Array.isArray(protocolsOrOptions) ? protocolsOrOptions : maybeOptions;
        if (!globalThis.WebSocket && !options?.WebSocket) throw new Error("No WebSocket implementation found. Please provide a custom WebSocket constructor in the options.");
        this._urlProvider = url;
        this._protocolsProvider = protocols;
        this.reconnectOptions = {
            WebSocket: options?.WebSocket ?? WebSocket,
            maxRetries: options?.maxRetries ?? 3,
            connectionTimeout: options?.connectionTimeout === undefined ? 10000 : options.connectionTimeout,
            reconnectionDelay: options?.reconnectionDelay ?? ((n)=>Math.min(~~(1 << n) * 150, 10000))
        };
        this._createSocket();
        this._initInternalListeners();
    }
    _createSocket() {
        const url = typeof this._urlProvider === "function" ? this._urlProvider() : this._urlProvider;
        const protocols = typeof this._protocolsProvider === "function" ? this._protocolsProvider() : this._protocolsProvider;
        this._socket = createSocketWithTimeout(()=>new this.reconnectOptions.WebSocket(url, protocols), this.reconnectOptions.connectionTimeout);
    }
    _initInternalListeners() {
        const handleClose = ()=>{
            this._socket.removeEventListener("error", handleError);
            this._close();
        };
        const handleError = ()=>{
            this._socket.removeEventListener("close", handleClose);
            this._close();
        };
        this._socket.addEventListener("open", this._open, {
            once: true
        });
        this._socket.addEventListener("close", handleClose, {
            once: true
        });
        this._socket.addEventListener("error", handleError, {
            once: true
        });
    }
    _open = ()=>{
        // Reset the attempt counter
        this._attempt = 0;
        // Send all buffered messages
        this._messageBuffer.forEach((item)=>{
            this._socket.send(item);
        });
        this._messageBuffer = [];
    };
    _close = async ()=>{
        try {
            // If the instance is terminated, do not attempt to reconnect
            if (this._abortController.signal.aborted) return;
            // Check if reconnection should be attempted
            if (++this._attempt > this.reconnectOptions.maxRetries) {
                this._cleanup("RECONNECTION_LIMIT");
                return;
            }
            // Delay before reconnecting
            const delay = typeof this.reconnectOptions.reconnectionDelay === "number" ? this.reconnectOptions.reconnectionDelay : this.reconnectOptions.reconnectionDelay(this._attempt);
            await sleep(delay, this._abortController.signal);
            // Create a new WebSocket instance and re-apply event listeners (and some properties)
            const { onclose, onerror, onmessage, onopen, binaryType } = this._socket; // preserve event handlers
            this._createSocket();
            this._initInternalListeners();
            this._listeners.forEach(({ type, listenerProxy, options })=>{
                this._socket.addEventListener(type, listenerProxy, options);
            });
            this._socket.onclose = onclose;
            this._socket.onerror = onerror;
            this._socket.onmessage = onmessage;
            this._socket.onopen = onopen;
            this._socket.binaryType = binaryType;
        } catch (error) {
            this._cleanup("UNKNOWN_ERROR", error);
        }
    };
    _cleanup(code, cause) {
        const error = new ReconnectingWebSocketError(code, cause);
        this._abortController.abort(error);
        this._socket.close();
        this.dispatchEvent(new CustomEvent("terminate", {
            detail: error
        }));
    }
    // WebSocket property implementations
    get url() {
        return this._socket.url;
    }
    get readyState() {
        return this._socket.readyState;
    }
    get bufferedAmount() {
        return this._socket.bufferedAmount;
    }
    get extensions() {
        return this._socket.extensions;
    }
    get protocol() {
        return this._socket.protocol;
    }
    get binaryType() {
        return this._socket.binaryType;
    }
    set binaryType(value) {
        this._socket.binaryType = value;
    }
    CONNECTING = 0;
    OPEN = 1;
    CLOSING = 2;
    CLOSED = 3;
    static CONNECTING = 0;
    static OPEN = 1;
    static CLOSING = 2;
    static CLOSED = 3;
    get onclose() {
        return this._socket.onclose;
    }
    set onclose(value) {
        this._socket.onclose = value;
    }
    get onerror() {
        return this._socket.onerror;
    }
    set onerror(value) {
        this._socket.onerror = value;
    }
    get onmessage() {
        return this._socket.onmessage;
    }
    set onmessage(value) {
        this._socket.onmessage = value;
    }
    get onopen() {
        return this._socket.onopen;
    }
    set onopen(value) {
        this._socket.onopen = value;
    }
    /**
     * @param permanently - If `true`, the connection will be permanently closed. Default is `true`.
     */ close(code, reason, permanently = true) {
        this._socket.close(code, reason);
        if (permanently) this._cleanup("TERMINATED_BY_USER");
    }
    /**
     * @note If the connection is not open, the data will be buffered and sent when the connection is established.
     */ send(data) {
        if (this._socket.readyState !== ReconnectingWebSocket.OPEN && !this._abortController.signal.aborted) this._messageBuffer.push(data);
        else this._socket.send(data);
    }
    addEventListener(type, listener, options) {
        // Wrap the listener to handle reconnection
        let listenerProxy;
        if (this._abortController.signal.aborted) // If the instance is terminated, use the original listener
        listenerProxy = listener;
        else {
            // Check if the listener is already registered
            const index = this._listeners.findIndex((e)=>listenersMatch(e, {
                    type,
                    listener,
                    options
                }));
            if (index !== -1) // Use the existing listener proxy
            listenerProxy = this._listeners[index].listenerProxy;
            else {
                // Wrap the original listener to follow the once option when reconnecting
                listenerProxy = (event)=>{
                    try {
                        if (typeof listener === "function") listener.call(this, event);
                        else listener.handleEvent(event);
                    } finally{
                        // If the listener is marked as once, remove it after the first invocation
                        if (typeof options === "object" && options.once === true) {
                            const index = this._listeners.findIndex((e)=>listenersMatch(e, {
                                    type,
                                    listener,
                                    options
                                }));
                            if (index !== -1) this._listeners.splice(index, 1);
                        }
                    }
                };
                this._listeners.push({
                    type,
                    listener,
                    options,
                    listenerProxy
                });
            }
        }
        // Add the wrapped (or original) listener
        this._socket.addEventListener(type, listenerProxy, options);
    }
    removeEventListener(type, listener, options) {
        // Remove a wrapped listener, not an original listener
        const index = this._listeners.findIndex((e)=>listenersMatch(e, {
                type,
                listener,
                options
            }));
        if (index !== -1) {
            const { listenerProxy } = this._listeners[index];
            this._socket.removeEventListener(type, listenerProxy, options);
            this._listeners.splice(index, 1);
        } else // If the wrapped listener is not found, remove the original listener
        this._socket.removeEventListener(type, listener, options);
    }
    dispatchEvent(event) {
        return this._socket.dispatchEvent(event);
    }
}
/** @see https://developer.mozilla.org/en-US/docs/Web/API/DOMException */ const DOMException_ = /* @__PURE__ */ (()=>{
    return globalThis.DOMException || class DOMExceptionPolyfill extends Error {
        constructor(message = "", name = "Error"){
            super(message);
            this.name = name;
        }
    };
})();
const AbortSignal_ = /* @__PURE__ */ (()=>{
    return {
        /** @see https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/timeout_static */ timeout: AbortSignal?.timeout ? (ms)=>AbortSignal.timeout(ms) : (ms)=>{
            const controller = new AbortController();
            setTimeout(()=>controller.abort(new DOMException_("Signal timed out.", "TimeoutError")), ms);
            return controller.signal;
        }
    };
})();
function createSocketWithTimeout(socketFactory, timeout) {
    const socket = socketFactory();
    if (timeout === null) return socket;
    const handleOpen = ()=>{
        socket.removeEventListener("close", handleClose);
        socket.removeEventListener("error", handleError);
        signal.removeEventListener("abort", handleAbort);
    };
    const handleClose = ()=>{
        socket.removeEventListener("open", handleOpen);
        socket.removeEventListener("error", handleError);
        signal.removeEventListener("abort", handleAbort);
    };
    const handleError = ()=>{
        socket.removeEventListener("open", handleOpen);
        socket.removeEventListener("close", handleClose);
        signal.removeEventListener("abort", handleAbort);
    };
    const handleAbort = ()=>{
        socket.close(3008, "Timeout"); // https://www.iana.org/assignments/websocket/websocket.xml#close-code-number
    };
    const signal = AbortSignal_.timeout(timeout);
    socket.addEventListener("open", handleOpen, {
        once: true,
        signal
    });
    socket.addEventListener("close", handleClose, {
        once: true,
        signal
    });
    socket.addEventListener("error", handleError, {
        once: true,
        signal
    });
    signal.addEventListener("abort", handleAbort, {
        once: true
    });
    return socket;
}
function listenersMatch(a, b) {
    const aCapture = typeof a.options === "object" ? a.options.capture : a.options;
    const bCapture = typeof b.options === "object" ? b.options.capture : b.options;
    return a.type === b.type && a.listener === b.listener && !!aCapture === !!bCapture;
}
function sleep(ms, signal) {
    if (signal?.aborted) return Promise.reject(signal.reason);
    return new Promise((resolve, reject)=>{
        const onAbort = ()=>{
            clearTimeout(timer);
            reject(signal?.reason);
        };
        const onTimeout = ()=>{
            signal?.removeEventListener("abort", onAbort);
            resolve();
        };
        const timer = setTimeout(onTimeout, ms);
        signal?.addEventListener("abort", onAbort, {
            once: true
        });
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gKyNT":[function(require,module,exports) {
module.exports = require("bfb19f1f70bf147")(require("7c299a68cb785182").resolve("dVcvk")).then(()=>module.bundle.root("7wVf9"));

},{"bfb19f1f70bf147":"hpx0h","7c299a68cb785182":"fyJL2"}],"a1Sgr":[function(require,module,exports) {
module.exports = require("8c7a744112c20846")(require("bc215b369e5acd08").resolve("7SBQa")).then(()=>module.bundle.root("N7M1B"));

},{"8c7a744112c20846":"hpx0h","bc215b369e5acd08":"fyJL2"}],"6WxCn":[function(require,module,exports) {
module.exports = require("cc868cec43cccc06")(require("9f2c9f5f31adae37").resolve("kNLVx")).then(()=>module.bundle.root("cI8hw"));

},{"cc868cec43cccc06":"hpx0h","9f2c9f5f31adae37":"fyJL2"}],"8SJmv":[function(require,module,exports) {
module.exports = require("e73e8ac07c91f146")(require("2428a9ea6592d30f").resolve("6nVKT")).then(()=>module.bundle.root("1UyDU"));

},{"e73e8ac07c91f146":"hpx0h","2428a9ea6592d30f":"fyJL2"}],"2J4qA":[function(require,module,exports) {
module.exports = require("4b935d83c2fece24")(require("b8d2e3eaf9a92fe9").resolve("14QDh")).then(()=>module.bundle.root("8A1Yz"));

},{"4b935d83c2fece24":"hpx0h","b8d2e3eaf9a92fe9":"fyJL2"}],"8dMQO":[function(require,module,exports) {
module.exports = require("a5de393b7796c079")(require("f2555b67d2296b6b").resolve("2zjTs")).then(()=>module.bundle.root("mo8zj"));

},{"a5de393b7796c079":"hpx0h","f2555b67d2296b6b":"fyJL2"}],"bEKLz":[function(require,module,exports) {
module.exports = require("83c8b8b45a9d705c")(require("adfcaec848abbd52").resolve("iOSSR")).then(()=>module.bundle.root("f1QHr"));

},{"83c8b8b45a9d705c":"hpx0h","adfcaec848abbd52":"fyJL2"}],"48zHh":[function(require,module,exports) {
module.exports = require("bb97173ddc78c574")(require("a073e290a5381076").resolve("jdd4K")).then(()=>module.bundle.root("gSHee"));

},{"bb97173ddc78c574":"hpx0h","a073e290a5381076":"fyJL2"}],"2mi3I":[function(require,module,exports) {
module.exports = require("f9b43fbaa647662b")(require("a949dd31ad95017d").resolve("e0Rep")).then(()=>module.bundle.root("boN4L"));

},{"f9b43fbaa647662b":"hpx0h","a949dd31ad95017d":"fyJL2"}],"ldtR5":[function(require,module,exports) {
module.exports = require("7a5d35f229713df5")(require("e9d96b5f8b3a8866").resolve("QdmLN")).then(()=>module.bundle.root("6OJ4a"));

},{"7a5d35f229713df5":"hpx0h","e9d96b5f8b3a8866":"fyJL2"}],"lPHNd":[function(require,module,exports) {
module.exports = require("79ede8252e769920")(require("d5f90ff86e599950").resolve("jqHnS")).then(()=>module.bundle.root("8ieI2"));

},{"79ede8252e769920":"hpx0h","d5f90ff86e599950":"fyJL2"}],"krUjc":[function(require,module,exports) {
module.exports = require("578c0244a82c461e")(require("3e9b9c64a20d5c39").resolve("95IVm")).then(()=>module.bundle.root("4OF6e"));

},{"578c0244a82c461e":"hpx0h","3e9b9c64a20d5c39":"fyJL2"}],"gtb31":[function(require,module,exports) {
module.exports = require("f94ee04f2c3cd027")(require("ea899a02d4db8b9b").resolve("j5vQM")).then(()=>module.bundle.root("cDCAE"));

},{"f94ee04f2c3cd027":"hpx0h","ea899a02d4db8b9b":"fyJL2"}],"jRTqj":[function(require,module,exports) {
module.exports = require("493d672ed4d12c77")(require("b5072bd13d6267b").resolve("kuwyQ")).then(()=>module.bundle.root("1DfC8"));

},{"493d672ed4d12c77":"hpx0h","b5072bd13d6267b":"fyJL2"}],"1tpGP":[function(require,module,exports) {
module.exports = require("f35792fc7dbacb6f")(require("2ab200d1632a7adc").resolve("hpmJK")).then(()=>module.bundle.root("juDwX"));

},{"f35792fc7dbacb6f":"hpx0h","2ab200d1632a7adc":"fyJL2"}],"7hEG8":[function(require,module,exports) {
module.exports = require("10c6a731738e92b4")(require("7085bee8b03d1d16").resolve("75rVb")).then(()=>module.bundle.root("exkcQ"));

},{"10c6a731738e92b4":"hpx0h","7085bee8b03d1d16":"fyJL2"}],"21AMv":[function(require,module,exports) {
module.exports = require("2340097d46a6f35f")(require("16a1b40ee145802c").resolve("jvVie")).then(()=>module.bundle.root("4Kk1B"));

},{"2340097d46a6f35f":"hpx0h","16a1b40ee145802c":"fyJL2"}],"3GCVy":[function(require,module,exports) {
module.exports = require("408359ce386ceec9")(require("b1dbb6d471b8fed4").resolve("1Rec2")).then(()=>module.bundle.root("8hqyP"));

},{"408359ce386ceec9":"hpx0h","b1dbb6d471b8fed4":"fyJL2"}],"8xBP8":[function(require,module,exports) {
module.exports = require("827c34931e60c4e9")(require("f470cc79baf4763e").resolve("eP5WB")).then(()=>module.bundle.root("5YXTA"));

},{"827c34931e60c4e9":"hpx0h","f470cc79baf4763e":"fyJL2"}],"2wlKu":[function(require,module,exports) {
module.exports = require("aba3fe9b413f02bb")(require("2382f090e5dc35f3").resolve("cSUAJ")).then(()=>module.bundle.root("9FRzR"));

},{"aba3fe9b413f02bb":"hpx0h","2382f090e5dc35f3":"fyJL2"}],"fYaZG":[function(require,module,exports) {
module.exports = require("76115b3d094ec00e")(require("3d35c95733215df").resolve("ktfFT")).then(()=>module.bundle.root("fqkhk"));

},{"76115b3d094ec00e":"hpx0h","3d35c95733215df":"fyJL2"}],"3eTZQ":[function(require,module,exports) {
module.exports = require("475b794e949b6d80")(require("f5841a260ba9118b").resolve("6vrJm")).then(()=>module.bundle.root("aCSiA"));

},{"475b794e949b6d80":"hpx0h","f5841a260ba9118b":"fyJL2"}],"bgxJ8":[function(require,module,exports) {
module.exports = require("39d214d3a521213a")(require("87d514c9ad222e0d").resolve("ahuud")).then(()=>module.bundle.root("a0kxV"));

},{"39d214d3a521213a":"hpx0h","87d514c9ad222e0d":"fyJL2"}],"7Spzc":[function(require,module,exports) {
module.exports = require("3b001b7f7654ae12")(require("bce33a515dad22bb").resolve("ju3C7")).then(()=>module.bundle.root("9ktb7"));

},{"3b001b7f7654ae12":"hpx0h","bce33a515dad22bb":"fyJL2"}],"aZ4P9":[function(require,module,exports) {
module.exports = require("d98c6006bba35999")(require("f2aee2694c1f3542").resolve("8TPB0")).then(()=>module.bundle.root("l27MP"));

},{"d98c6006bba35999":"hpx0h","f2aee2694c1f3542":"fyJL2"}],"9k7cc":[function(require,module,exports) {
module.exports = require("6a8a346cdc0b164b")(require("2605420dc2ff6dc8").resolve("dKktD")).then(()=>module.bundle.root("5l2YZ"));

},{"6a8a346cdc0b164b":"hpx0h","2605420dc2ff6dc8":"fyJL2"}],"91Iyr":[function(require,module,exports) {
module.exports = require("4cc3e0367993afc1")(require("97eecf66b27ad639").resolve("1nR1M")).then(()=>module.bundle.root("eqGXI"));

},{"4cc3e0367993afc1":"hpx0h","97eecf66b27ad639":"fyJL2"}],"kRz8l":[function(require,module,exports) {
module.exports = require("481997bab56db8d8")(require("3daeeef0d5b454d0").resolve("aJj8f")).then(()=>module.bundle.root("3CxmS"));

},{"481997bab56db8d8":"hpx0h","3daeeef0d5b454d0":"fyJL2"}],"f89mb":[function(require,module,exports) {
module.exports = require("23efd76a28bfece0")(require("8d61dd70a56cb6f1").resolve("k2nJc")).then(()=>module.bundle.root("cMuma"));

},{"23efd76a28bfece0":"hpx0h","8d61dd70a56cb6f1":"fyJL2"}],"8cxG0":[function(require,module,exports) {
module.exports = require("44a56bf3a1341e0b")(require("c0394dd428d95c06").resolve("5hQ26")).then(()=>module.bundle.root("3MkQT"));

},{"44a56bf3a1341e0b":"hpx0h","c0394dd428d95c06":"fyJL2"}],"fuLOH":[function(require,module,exports) {
module.exports = require("79d1a9aa27b5a0f0")(require("9effb843be8462ff").resolve("20EWj")).then(()=>module.bundle.root("dag7C"));

},{"79d1a9aa27b5a0f0":"hpx0h","9effb843be8462ff":"fyJL2"}],"Z3dTd":[function(require,module,exports) {
module.exports = require("9c3c2d9228c4e037")(require("ed1f069c874ed00d").resolve("257xd")).then(()=>module.bundle.root("kpQGh"));

},{"9c3c2d9228c4e037":"hpx0h","ed1f069c874ed00d":"fyJL2"}],"besK2":[function(require,module,exports) {
module.exports = require("5dcfefa19bc64855")(require("59efb3595eb290cd").resolve("5YLOB")).then(()=>module.bundle.root("hMF7j"));

},{"5dcfefa19bc64855":"hpx0h","59efb3595eb290cd":"fyJL2"}],"3WjRM":[function(require,module,exports) {
module.exports = require("9f9830a23a458e4c")(require("d79187d509bd8443").resolve("clg2W")).then(()=>module.bundle.root("2VbJB"));

},{"9f9830a23a458e4c":"hpx0h","d79187d509bd8443":"fyJL2"}],"4dWYW":[function(require,module,exports) {
module.exports = require("ca7eebf8be1314ad")(require("21ecb85065719286").resolve("cYyjx")).then(()=>module.bundle.root("fNnk0"));

},{"ca7eebf8be1314ad":"hpx0h","21ecb85065719286":"fyJL2"}],"fahcO":[function(require,module,exports) {
module.exports = require("f47e9fd91fb339f2")(require("593e6213f9cb0719").resolve("hQARm")).then(()=>module.bundle.root("5DZPH"));

},{"f47e9fd91fb339f2":"hpx0h","593e6213f9cb0719":"fyJL2"}],"4fphA":[function(require,module,exports) {
module.exports = require("a22073a420ae26be")(require("6180dece980a49bd").resolve("4c16t")).then(()=>module.bundle.root("kxT6z"));

},{"a22073a420ae26be":"hpx0h","6180dece980a49bd":"fyJL2"}],"dipmP":[function(require,module,exports) {
module.exports = require("17a9f9d7bc7ea8b9")(require("92158b0a720491b4").resolve("2W8Qq")).then(()=>module.bundle.root("dF7ZY"));

},{"17a9f9d7bc7ea8b9":"hpx0h","92158b0a720491b4":"fyJL2"}],"9QXik":[function(require,module,exports) {
module.exports = require("6e468987ede8580")(require("3a6841d1b05e1cfc").resolve("gia0u")).then(()=>module.bundle.root("75GTL"));

},{"6e468987ede8580":"hpx0h","3a6841d1b05e1cfc":"fyJL2"}],"03fHo":[function(require,module,exports) {
module.exports = require("f15dbcb5cd1ee7d9")(require("d9fff254ae07007f").resolve("7v639")).then(()=>module.bundle.root("5EgzO"));

},{"f15dbcb5cd1ee7d9":"hpx0h","d9fff254ae07007f":"fyJL2"}],"1mGBB":[function(require,module,exports) {
module.exports = require("539b33738b6d8311")(require("46b7da085be7b8f6").resolve("OfjZN")).then(()=>module.bundle.root("BJ8kO"));

},{"539b33738b6d8311":"hpx0h","46b7da085be7b8f6":"fyJL2"}],"eiIRf":[function(require,module,exports) {
module.exports = require("2e1bd49a9e2d9387")(require("e0725d370ded4003").resolve("jNzC2")).then(()=>module.bundle.root("3UfyQ"));

},{"2e1bd49a9e2d9387":"hpx0h","e0725d370ded4003":"fyJL2"}],"dD3X6":[function(require,module,exports) {
module.exports = require("2a9d707d93c275fb")(require("b67cf5aa9f134c49").resolve("3UHWR")).then(()=>module.bundle.root("eq61v"));

},{"2a9d707d93c275fb":"hpx0h","b67cf5aa9f134c49":"fyJL2"}],"5CY5G":[function(require,module,exports) {
module.exports = require("d2c53b980fd1ea12")(require("ad994e9691d6bdf1").resolve("5JGOU")).then(()=>module.bundle.root("5Ae6d"));

},{"d2c53b980fd1ea12":"hpx0h","ad994e9691d6bdf1":"fyJL2"}],"e8eUp":[function(require,module,exports) {
module.exports = require("98604b90ca5a8247")(require("5f139f2af37a3fab").resolve("cqhLa")).then(()=>module.bundle.root("bfxrh"));

},{"98604b90ca5a8247":"hpx0h","5f139f2af37a3fab":"fyJL2"}],"f4kPj":[function(require,module,exports) {
module.exports = require("f4931021ec5e9edc")(require("c080589c71eadb8d").resolve("7cQwd")).then(()=>module.bundle.root("8MMWT"));

},{"f4931021ec5e9edc":"hpx0h","c080589c71eadb8d":"fyJL2"}],"5hAXt":[function(require,module,exports) {
module.exports = require("94d42fc7e4273a56")(require("9a39749322e67181").resolve("lEVfn")).then(()=>module.bundle.root("3Fu63"));

},{"94d42fc7e4273a56":"hpx0h","9a39749322e67181":"fyJL2"}],"04Atm":[function(require,module,exports) {
module.exports = require("d8dc7866bc44d651")(require("7f1c2ec077dc776c").resolve("dmlb4")).then(()=>module.bundle.root("iQt0J"));

},{"d8dc7866bc44d651":"hpx0h","7f1c2ec077dc776c":"fyJL2"}],"brsVh":[function(require,module,exports) {
module.exports = require("dab94c5f480b9ba9")(require("7662ecde9a33c23c").resolve("ajzeL")).then(()=>module.bundle.root("ke0vM"));

},{"dab94c5f480b9ba9":"hpx0h","7662ecde9a33c23c":"fyJL2"}],"l07GF":[function(require,module,exports) {
module.exports = require("aa48007f44e1f9cf")(require("c7c8b219c315c64c").resolve("3muPS")).then(()=>module.bundle.root("dyhU7"));

},{"aa48007f44e1f9cf":"hpx0h","c7c8b219c315c64c":"fyJL2"}],"dc5hV":[function(require,module,exports) {
module.exports = require("f03a45176795e21d")(require("4bbe76253daeda09").resolve("cTJLt")).then(()=>module.bundle.root("ihtxD"));

},{"f03a45176795e21d":"hpx0h","4bbe76253daeda09":"fyJL2"}],"bTq5d":[function(require,module,exports) {
module.exports = require("d654740881f02f1c")(require("8222000f4506661e").resolve("llb2B")).then(()=>module.bundle.root("3rcOX"));

},{"d654740881f02f1c":"hpx0h","8222000f4506661e":"fyJL2"}],"it3xb":[function(require,module,exports) {
module.exports = require("de40d8b31a44e006")(require("c62877e7848fa1c9").resolve("lKOLb")).then(()=>module.bundle.root("cZNhs"));

},{"de40d8b31a44e006":"hpx0h","c62877e7848fa1c9":"fyJL2"}],"5NfyA":[function(require,module,exports) {
module.exports = require("350106dbfbac4863")(require("72a9c53dd65ea7fb").resolve("5RqXX")).then(()=>module.bundle.root("hHh7x"));

},{"350106dbfbac4863":"hpx0h","72a9c53dd65ea7fb":"fyJL2"}],"4cJ95":[function(require,module,exports) {
module.exports = require("659724e38025d745")(require("beaff201f28c51df").resolve("QEpwI")).then(()=>module.bundle.root("91bnv"));

},{"659724e38025d745":"hpx0h","beaff201f28c51df":"fyJL2"}],"lAONF":[function(require,module,exports) {
module.exports = require("fe9d6565dfddbbb8")(require("f163939f61e181a1").resolve("ef0Jm")).then(()=>module.bundle.root("2MNVj"));

},{"fe9d6565dfddbbb8":"hpx0h","f163939f61e181a1":"fyJL2"}],"1W6z0":[function(require,module,exports) {
module.exports = require("f9d322798de72f11")(require("1f37df753036d3ae").resolve("de8wm")).then(()=>module.bundle.root("lOeMY"));

},{"f9d322798de72f11":"hpx0h","1f37df753036d3ae":"fyJL2"}],"6D5WW":[function(require,module,exports) {
module.exports = require("22d2f3cc04e055fa")(require("69da044074b78d86").resolve("7s5QD")).then(()=>module.bundle.root("8QgrV"));

},{"22d2f3cc04e055fa":"hpx0h","69da044074b78d86":"fyJL2"}],"b3N5W":[function(require,module,exports) {
module.exports = require("569bafc7c5a5823b")(require("339e796cc453ac56").resolve("91Lro")).then(()=>module.bundle.root("6cLxi"));

},{"569bafc7c5a5823b":"hpx0h","339e796cc453ac56":"fyJL2"}],"k95D2":[function(require,module,exports) {
module.exports = require("cf887bc12d2d02e0")(require("a7f538c621d91f80").resolve("ho7rd")).then(()=>module.bundle.root("fReZb"));

},{"cf887bc12d2d02e0":"hpx0h","a7f538c621d91f80":"fyJL2"}],"afemA":[function(require,module,exports) {
module.exports = require("128c529fea87dc36")(require("eb9eac47c533415").resolve("aZzFr")).then(()=>module.bundle.root("7gloV"));

},{"128c529fea87dc36":"hpx0h","eb9eac47c533415":"fyJL2"}],"eX6l3":[function(require,module,exports) {
module.exports = require("9d8c307cdaf8f7dc")(require("dcc977a96fac0a25").resolve("4SbtD")).then(()=>module.bundle.root("jyJwv"));

},{"9d8c307cdaf8f7dc":"hpx0h","dcc977a96fac0a25":"fyJL2"}],"idtxH":[function(require,module,exports) {
module.exports = require("f1c5140ebb3ced1e")(require("3a262dd2e94c6a87").resolve("f4SOf")).then(()=>module.bundle.root("6Pc33"));

},{"f1c5140ebb3ced1e":"hpx0h","3a262dd2e94c6a87":"fyJL2"}],"m1NRc":[function(require,module,exports) {
module.exports = require("b147c874bcbfcdb1")(require("e70a3d4a401d5952").resolve("hBDBK")).then(()=>module.bundle.root("ldVfF"));

},{"b147c874bcbfcdb1":"hpx0h","e70a3d4a401d5952":"fyJL2"}],"dJYr2":[function(require,module,exports) {
module.exports = require("2dd7a5720d76f5cd")(require("f418f4268a0e6aae").resolve("2o74t")).then(()=>module.bundle.root("aCipR"));

},{"2dd7a5720d76f5cd":"hpx0h","f418f4268a0e6aae":"fyJL2"}],"iDqEx":[function(require,module,exports) {
module.exports = require("f0069b02b755e16d")(require("f17ac925c5a90d2f").resolve("5ZRJS")).then(()=>module.bundle.root("6aGE0"));

},{"f0069b02b755e16d":"hpx0h","f17ac925c5a90d2f":"fyJL2"}],"8kiyi":[function(require,module,exports) {
module.exports = require("f73a01aa56c80c39")(require("d0878370ba68f678").resolve("8C1BM")).then(()=>module.bundle.root("5dYha"));

},{"f73a01aa56c80c39":"hpx0h","d0878370ba68f678":"fyJL2"}],"dLch8":[function(require,module,exports) {
module.exports = require("28f576ee498e1458")(require("8863317693ca8a96").resolve("9otOP")).then(()=>module.bundle.root("cx5ri"));

},{"28f576ee498e1458":"hpx0h","8863317693ca8a96":"fyJL2"}],"61bFV":[function(require,module,exports) {
module.exports = require("8235291a3ea928b8")(require("122c3bfbdc907fa0").resolve("CUJ9S")).then(()=>module.bundle.root("c4tci"));

},{"8235291a3ea928b8":"hpx0h","122c3bfbdc907fa0":"fyJL2"}],"dTU9H":[function(require,module,exports) {
module.exports = require("d2b516cb3c837cae")(require("7cf641f19fc738f0").resolve("7SGkM")).then(()=>module.bundle.root("f020E"));

},{"d2b516cb3c837cae":"hpx0h","7cf641f19fc738f0":"fyJL2"}],"bYeQK":[function(require,module,exports) {
module.exports = require("cc1d588288589599")(require("d5dc60b75e0a73a").resolve("3Eoqt")).then(()=>module.bundle.root("jAxlM"));

},{"cc1d588288589599":"hpx0h","d5dc60b75e0a73a":"fyJL2"}],"6svRp":[function(require,module,exports) {
module.exports = require("96c8b9ec29362d2d")(require("f9fdf2b643524324").resolve("dzqic")).then(()=>module.bundle.root("KsExq"));

},{"96c8b9ec29362d2d":"hpx0h","f9fdf2b643524324":"fyJL2"}]},["3sHWr","8RSWf"], "8RSWf", "parcelRequire819c")

//# sourceMappingURL=index.js.map
